module.exports = __webpack_public_path__ + "img/down_empty.7c0e6328.png";